const messages = {
	en: {
		translations: {
			signup: {
				title: "Sign up",
				toasts: {
					success: "User created successfully! Please login!",
					fail: "Error creating user. Check the reported data.",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Register",
					login: "Already have an account? Log in!",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Enter",
					register: "Register",
					restart: "Did you forget your password ? restore it"

				},
			},
			companies: {
				title: "Register Companies",
				form: {
					name: "Name Companies",
					plan: "Plant",
					token: "Token",
					submit: "Register",
					success: "The enterprise done!",
				},
			},
			auth: {
				toasts: {
					success: "Login successfully!",
				},
				token: "Token",

			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets today: ",
					},
				},
			},
			dashboardGeneral: {
				greeting: {
					morning: "Good morning!",
					afternoon: "Good afternoon!",
					evening: "Good evening!",
				},
				weekdays: {
					sunday: "Sunday",
					monday: "Monday",
					tuesday: "Tuesday",
					wednesday: "Wednesday",
					thursday: "Thursday",
					friday: "Friday",
					saturday: "Saturday",
				},
				months: {
					january: "January",
					february: "February",
					march: "March",
					april: "April",
					may: "May",
					june: "June",
					july: "July",
					august: "August",
					september: "September",
					october: "October",
					november: "November",
					december: "December",
				},
				dateJoiner: "",
				filterButton: "Filter",
				periods: {
					hoy: "Today",
					ayer: "Yesterday",
					hoyAyer: "Hoy y ayer",
					semana: "This week",
					semanaPasada: "Last week",
					mes: "This month",
					mesPasado: "Last month",
					tresMeses: "Last 3 months",
					dia: "Specific day",
				},
				allAgents: "All agents",
				allGroups: "All groups",
				showing: "Showing:",
				rightNow: "right now",
				scopesTitle: "What we close with, day by day",
				scopesEmpty: "No closure with a scope in the last 14 days",
				trendScope: "last 14 days",
				adsScope: "last 5 ads · whole company",
				adsDailyTotal: "chats from ads in 30 days",
				adsDailyEmpty: "No ad brought chats in 30 days",
				adUnnamed: "Ad",
				adPerChat: "per chat",
				adSpend: "spent",
				adNotSynced: "campaign not synced",
				adFrom: "from",
				adActive: "active",
				adLast: "last",
				vsPrev: "vs the same day last week",
				vsPeriod: "vs the previous period",
				flow: {
					title: "Handling flow",
					source: "live tracking",
					wait: "Wait",
					firstReply: "First reply",
					firstReplyHint: "Until an agent writes",
					target: "target",
					noTarget: "no data",
					defaultTarget: "default target",
					nineOfTen: "9 out of 10, under",
					waitHint: "From entering the queue until picked up",
					handle: "Handling",
					handleHint: "From pick-up until close",
					reopens: "Reopens",
					reopensHint: "Closed chats that opened again",
					transfers: "Transfers",
					transfersHint: "Chats that changed agent",
					returns: "Returns",
					returnsHint: "Chats sent back to the queue",
				},
				kpis: {
					totalActive: "Total active",
					incoming: "Incoming",
					recurrence: "Recurrence",
					newClients: "New clients",
					returningClients: "Returning clients",
					returningLabel: "had written before",
					hints: {
						incoming: "Received in the period",
						closed: "Resolved in the period",
						recurrence: "Had written before",
						medianTime: "Typical length",
						backlogNow: "In queue right now",
						newClients: "Writing for the first time",
						returningClients: "Clients coming back",
					},
					contactsSuffix: " contacts",
					medianTime: "Median time",
					backlogNow: "Backlog now",
					workingSuffix: " working",
					pending: "Pending",
					open: "In progress",
					closedToday: "Closed",
					bot: "By bot",
					agentsOnline: "Agents online",
					agentsWorking: "Agents working",
					resolutionSuffix: "% resolved",
					botSuffix: "% of total",
					loadSuffix: " active / agent",
					activeSuffix: " of {n} active",
					callsReceived: "Calls received",
					uniqueContacts: "Unique contacts",
					totalChats: "Chats received",
					repeatSuffix: " returning",
					callsRated: "Rated",
					callsAvg: "Average rating",
				},
				help: {
					trend: "Chats that came in and chats that were closed, one point per day.\nFixed 14-day window: it does not change with the date filter. Two full weeks, so each day sits next to its equivalent from the week before.\nIt does respond to the group and agent filters.\nDays with no activity show as zero, they are not skipped.",
					scopes: "Which scope each day was closed with, over the last 14 days.\nFixed window: it does not change with the date filter. It does respond to group and agent.\nEach band's thickness is how much that scope weighed THAT day. Useful to see one day was almost all informational and another was not.\nSame strict definition as \"Who closes what\": it only counts when the person who closed is the one who was handling it.",
					statusOverview: "Breakdown of chats that are live RIGHT NOW.\nDoes not change with the date filter: it is a snapshot.",
					byAgent: "Per agent: how many chats they hold now and how many they closed in the period.\nThe median is the typical handling time.",
					colWorking: "Chats they have open right now, not closed yet.",
					colAttended: "Every chat they touched in this period: the ones still open, plus the ones already closed.",
					colClosed: "Chats they already closed in this period.",
					colMedianTime: "How long it usually takes them to close a chat.\nNot a plain average: if one chat got left open all night by mistake, that odd case doesn't get to skew the number. It's the time of the chat \"in the middle\" (neither the fastest nor the slowest).",
					whoClosesWhat: "Closures grouped by scope.\nThey only count when the person who closed is the one who was handling it: a closure done by an admin is credited to nobody.\nClick any number to see the chats.",
					byAd: "The 5 ads with the most recent activity, with ALL their history.\nChanges with neither the date filter nor the group filter: ad spend belongs to the whole company, not to one queue.\nHere an admin's closure DOES count, because this measures the ad's result, not who to credit. That is why it may not match \"Who closes what\".",
					opportunities: "Two different things that do not add up:\nLeft: contacts that changed status during the period.\nRight: how the pipeline stands today (contacts active in the last 90 days), regardless of the chosen date.",
					flow: "Wait: from the chat entering the queue until someone takes it.\nHandling: from being taken until it is closed.\nThe median is shown, not the average: one chat forgotten overnight does not distort the rest.",
					byQueue: "What is still unresolved right now, split by queue.\nIt does not change when you change the dates above: this is always the present.\n\"No queue\" means chats nobody sees in their inbox.",
					byLine: "Chats that had some activity within the dates you picked, by the line they came in through.\nIt counts if the customer wrote, if someone replied, or if the chat changed state, even for a chat from months ago.\nOne nobody touched in those dates does not show up here.",
					calls: "Calls received and their survey.\n\"Not rated\" means the survey was sent and the customer has not replied yet. It does NOT mean the call went unanswered.\nThe score runs from 1 to 3.",
					ratings: "Score customers gave each agent, from 1 to 5.\n\"Spread\" shows whether scores are spread out or concentrated: an average of 2 can be all mediocre, or half excellent and half terrible.",
					reopens: "Chats that were closed and the customer wrote again.\nShows the reason they had been closed with and how many hours until they came back.\nComing back in under 4 hours (in red) is a premature close, not a new conversation.",
				},
				sections: {
					statusOverview: "Active chats",
					byAgent: "Chats by agent",
					byQueue: "Chats by queue",
					byLine: "Chats by connection",
					activityByAgent: "Agent activity",
					ungrouped: "Ungrouped",
					noQueue: "No queue",
					byCloseReason: "Closures by reason",
					whoClosesWhat: "Who closes what",
					byAd: "Meta ads",
					dailyChats: "Chats of the day",
					calls: "Calls",
					noReason: "No reason",
					otherScopes: "Other",
				},
				opportunitiesBlock: {
					opportunities: "Opportunities",
					flowTitle: "Changed status",
					stockTitle: "How they stand today",
					stockNote: "Contacts active in the last 90 days",
					flowEmpty: "Nobody changed status",
					stockEmpty: "No contact has a status",
					dailyTotal: "changes in 30 days",
					dailyEmpty: "No status changes in the last 30 days",
				},
				reopensBlock: {
					title: "Chats that came back",
					reason: "Closed as",
					who: "Closed by",
					count: "Times",
					back: "Came back after",
					empty: "No chat reopened in this period",
					hours: "h",
					dailyTotal: "reopens in 30 days",
					dailyEmpty: "No reopens in the last 30 days",
				},
				trendBlock: {
					title: "Day by day",
					empty: "No data in this period",
				},
				ratingsBlock: {
					title: "How each agent is rated",
					average: "Average",
					spread: "Spread",
					count: "Ratings",
					empty: "Nobody has rated in this period yet",
					seeDetail: "See the detail",
					detailTitle: "Ratings detail",
					detailAll: "All agents",
					colDate: "Date",
					colAgent: "Agent",
					colContact: "Contact",
					colQueue: "Queue",
					colRate: "Rating",
					colSource: "Source",
					colNote: "Note",
					colTicket: "Chat",
					srcSurvey: "Customer",
					srcAudit: "Audit",
					byAuditor: "by",
					noTicket: "No chat",
					noNote: "—",
					limitNote: "Showing the 300 most recent",
				},
				callsBlock: {
					received: "Received",
					rated: "Rated",
					pending: "Not rated yet",
					noCalls: "No calls came in",
					pendingHint: "Survey sent, still waiting for a reply",
					failed: "Callback failed",
					avgOf: "of",
					noRatings: "Nobody has rated yet",
					seeDetail: "See details",
					byLine: "By line",
					detailTitle: "Call details",
					colDate: "Came in",
					colContact: "Contact",
					colPhone: "Phone",
					colConnection: "Connection",
					colStatus: "Status",
					colRating: "Rating",
					colTicket: "Chat",
					noTicket: "No chat",
					limitNote: "Showing the 300 most recent",
				},
				statusNames: {
					open: "In progress",
					pending: "Pending",
					closed: "Closed",
					bot: "Bot",
				},
				statusLabels: {
					pending: "PENDING",
					open: "IN PROGRESS",
					closed: "CLOSED",
					bot: "WITH BOT",
					favorite: "FAVORITED",
				},
				table: {
					colChat: "Chat",
					colComment: "Comment",
					openChat: "Click to open the chat",
					noChat: "No chat",
					noConnection: "No connection",
					closuresOf: "Closures for",
					working: "Working",
					clickToFilter: "Click to filter by this agent",
					clickForDetail: "Click to see details",
					clickToExpand: "Click to see the agents",
					colContact: "Contact",
					otherCategories: "Others",
					colReason: "Reason",
					closeReasonsBreakdown: "Close reasons",
					colLine: "Line",
					colDate: "Date",
					pickCategory: "Pick a category",
					pickCategoryHint: "Click a category on the left to see its chats.",
					clickForList: "Click to see the chats",
					filterByAgent: "Filter by this agent",
					categories: "Categories",
					categoriesTotal: "Total: {{total}}",
					medianTime: "Median",
					sessions: "sessions",
					agent: "Agent",
					online: "Online",
					active: "Active",
					closed: "Closed",
					reason: "Reason",
					total: "Total",
					users: "Users",
					name: "Name",
					state: "Status",
					ticket: "Ticket",
					user: "User",
					connection: "Connection",
					comment: "Comment",
					lastUser: "Last user",
				},
				noResults: "No results found",
				loading: "Loading...",
				noComment: "No comment",
				noUser: "No user",
				details: "Details:",
				recordsOf: "Records for",
				close: "Close",
				ticketSingular: "ticket",
				ticketPlural: "tickets",
				unknownReason: "Unknown",
			},
			connections: {
				title: "Connections",
				toasts: {
					deleted: "WhatsApp connection deleted sucessfully!",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? It cannot be reverted.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to read QR Code again.",
				},
				buttons: {
					add: "Add WhatsApp",
					disconnect: "Disconnect",
					reconnect: "Reconnect",
					tryAgain: "Try Again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connectiing",
					newConnection: "New Connection",
				},
				status: {
					connected: "Connected",
					disconnected: "Disconnected",
					pending: "Pending",
					qrcode: "Scan QR",
					opening: "Connecting…",
					timeout: "Timed out",
					pairing: "Pairing",
				},
				state: {
					new: "New",
					warmingUp: "Warming Up",
					asset: "Active",
					rest: "Resting",
					punished: "Punished",
				},
				chips: {
					lineSingular: "line",
					linePlural: "lines",
					connectedSingular: "connected",
					connectedPlural: "connected",
					default: "Default",
					backup: "Backup",
					botActive: "Has an active AI Prompt (bot)",
					n8nActive: "Has an active n8n integration",
				},
				rowActions: {
					edit: "Edit",
					delete: "Delete",
				},
				emptyChannel: "No connections configured for this channel.",
				search: {
					placeholder: "Search...",
					noResults: "No connection matches the search.",
				},
				toolTips: {
					disconnected: {
						title: "Failed to start WhatsApp session",
						content:
							"Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code read",
						content:
							"Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
					},
					connected: {
						title: "Connection established",
					},
					timeout: {
						title: "Connection with cell phone has been lost",
						content:
							"Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
					},
				},
				table: {
					name: "Name",
					operational_status: "Functional status",
					connection_status: "Connection status",
					lastUpdate: "Last Update",
					default: "Default",
					actions: "Actions",
					session: "Session",
					nameNumber: "Name / Number",
					state: "Status",
					operational: "Operational",
					credits: "Credits",
					department: "Department",
					automation: "Automation",
					flags: "Flags",
				},
			},
			whatsappModal: {
				title: {
					add: "Add WhatsApp",
					edit: "Edit WhatsApp",
				},
				tabs: {
					general: "General",
					api: "API",
					bot: "Bot",
					campaigns: "Campaigns",
				},
				sections: {
					identification: "Line identification",
					autoMessages: "Automatic messages",
					routing: "Routing",
					token: "Access token",
					operationalState: "Sending speed",
					bulk: "Bulk messaging",
					backupLine: "Backup line",
				},
				operationalState: {
					placeholder: "Line status",
					none: "No status",
					new: "New connection",
					warmingUp: "Warming Up",
					rest: "Resting",
					punished: "Punished",
				},
				deliverySpeed: {
					placeholder: "Sending speed (ms)",
					none: "No speed",
					sec2: "2 seconds",
					sec5: "5 seconds",
					sec10: "10 seconds",
					sec15: "15 seconds",
					sec20: "20 seconds",
					sec30: "30 seconds",
					sec45: "45 seconds",
					min1: "1 minute",
					min2: "2 minutes",
					min3: "3 minutes",
					min5: "5 minutes",
					min10: "10 minutes",
				},
				form: {
					name: "Name",
					default: "Default",
					defaultDesc: "This connection will be used automatically when no other one is specified.",
					number: "Number",
					active: "Active",
					inactive: "Inactive",
					sendIdQueue: "Queue",
					timeSendQueue: "Redirect to queue after X minutes",
					queueRedirection: "Bot behavior",
					queueRedirectionDesc: "Set how many times and how often the bot retries contacting, and when to close chats due to inactivity.",
					routingDesc: "Choose how new messages are handled: with a numbered menu (Queues) or a smart assistant (Open.AI). You can only use one at a time.",
					prompt: "Open.AI",
					tokenDesc: "Generate this code to connect this line with other systems (your website, a CRM, etc.) and send messages automatically, as if it were an API.",
					operationalStateDesc: "Control how fast messages are sent to avoid WhatsApp blocking the number, especially if it's new or was recently recovered.",
					maxUseBotQueues: "Send bot X times",
					timeUseBotQueues: "Minutes between bot messages",
					expiresTicket: "Close open chats after X minutes",
					expiresInactiveMessage: "Inactivity closing message",
					bulkEnabled: "Enabled for bulk messaging / campaigns",
					bulkEnabledDesc: "Allows this line to be used for sending bulk messages",
					backupLineEnabled: "Use as backup line",
					backupLineDesc: "When another line can't send a message, this device will be used as a backup",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
			},
			qrCode: {
				message: "Read QrCode to start the session",
			},
			contacts: {
				title: "Contacts",
				toasts: {
					deleted: "Contact deleted sucessfully!",
				},
				searchPlaceholder: "Search ...",
				confirmationModal: {
					deleteTitle: "Delete",
					importTitlte: "Import contacts",
					deleteMessage:
						"Are you sure you want to delete this contact? All related tickets will be lost.",
					importMessage: "Do you want to import all contacts from the phone?",
				},
				buttons: {
					import: "Import Contacts",
					cate: "Add Category",
					add: "Add Contact",
				},
				table: {
					name: "Name",
					whatsapp: "WhatsApp",
					email: "Email",
					category: "Category",
					representative: "Representative",

					actions: "Actions",
				},
			},
			contactsCategori: {
				title: "Contact Category",
				buttons: {
					cate: "Add Category",
				},
				form: {
					name: "Category name",
				},
			},
			queueIntegrationModal: {
				title: {
					add: "Add project",
					edit: "Edit project",
				},
				form: {
					id: "ID",
					type: "Type",
					name: "Name",
					projectName: "Project Name",
					language: "Language",
					jsonContent: "JSON Content",
					urlN8N: "URL",
					typebotSlug: "Typebot - Slug",
					typebotExpires: "Minutes until a conversation expires",
					typebotKeywordFinish: "Word to finish the conversation",
					typebotUnknownMessage: "Invalid option message",
					typebotKeywordRestart: "Word to restart the flow",
					typebotRestartMessage: "Word to restart the message",
					typebotDelayMessage: "Interval (ms) between messages",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					test: "Test Bot",
				},
				messages: {
					testSuccess: "Integration tested successfully",
					addSuccess: "Integration added successfully",
					editSuccess: "Integration edited successfully",
				},
			},
			promptModal: {
				settings: {
					model: "Model",
					modelHelp: "OpenAI model that writes the chat replies.",
					apiKey: "API key",
					apiKeyHelp: "OpenAI key this agent works with; usage is billed to that account.",
					accent: "Accent",
					accentHelp: "Accent the AI speaks with when it replies by voice.",
					temperature: "Temperature",
					temperatureHelp: "Lower = more precise and consistent replies. Recommended: 0.3.",
					maxTokens: "Maximum reply length",
					maxTokensHelp: "Tokens it can use per reply. If too low, replies get cut off.",
					maxMessages: "History messages",
					maxMessagesHelp: "How many previous chat messages it reads to understand the context.",
					handoff: "Handoff department",
					handoffHelp: "Where the chat goes when the AI transfers it to an agent.",
				},
				form: {
					name: "Name",
					prompt: "Prompt",
					promptEditorLabel: "Edit",
					promptPreviewLabel: "Preview",
					promptPreviewEmpty: "The prompt is empty.",
					voice: "Voice",
					max_tokens: "Max tokens in the response",
					temperature: "Temperature",
					apikey: "API Key",
					max_messages: "Max messages in history",
					voiceKey: "Voice API key",
					voiceRegion: "Voice region",
					model: "Text model",
					namePlaceholder: "Agent name",
					tabPrompt: "Prompt",
					tabSettings: "Settings",
					tabBasic: "Basic",
					type: "Type",
					tabWhatsapp: "WhatsApp (voice)",
					tabEspecialistas: "Specialists",
					tabHerramientas: "Tools",
					sectionWhatsappHelp: "If you pick a voice, the bot also replies with audio on WhatsApp, in addition to text.",
					sectionGeneral: "Settings",
					sectionVoiceAccent: "AI accent",
					voiceAccent: "Accent",
					voiceAccentHelp: "How the AI speaks (calls and avatar). Neutral = no accent instruction.",
					sectionModel: "Model",
					sectionLimits: "Limits",
					sectionHandoff: "Handoff",
					handoffQueue: "Hand off to",
					voiceNone: "No voice (text only)",
					avatarWebNota: "The website voice avatar's model and voice are configured in Connections → your Avatar connection, not here.",
					validacion: {
						requerido: "Required",
						nombreCorto: "Too short",
						nombreLargo: "Too long",
						promptCorto: "Describe the AI instructions (minimum 50 characters)",
						colaRequerida: "Pick a queue",
					},
					especialistas: {
						ayuda: "A specialist only replies when this prompt consults it, in chat or on a call. It doesn't handle customers on its own.",
						guardarPrimero: "Save the prompt first to configure specialists.",
						esEspecialistaDe: "This prompt is a specialist of",
						sinPadres: "This specialist isn't linked to any prompt yet. Link it from the text or call prompt that will use it.",
						quitarVinculo: "Remove link",
						vinculados: "Linked specialists",
						sinEspecialistas: "None yet.",
						cuandoUsarlo: "When to use it",
						cuandoUsarloPlaceholder: "E.g: use when the customer wants to track a shipment",
						vincularExistente: "Link an existing prompt",
						elegirPrompt: "Pick a prompt",
						vincular: "Link",
						vinculado: "Specialist linked",
						desvinculado: "Specialist unlinked",
						sinDisponibles: "No other prompts available to link as specialists.",
					},
					herramientas: {
						guardarPrimero: "Save the prompt first to configure tools.",
						configuradas: "Configured tools",
						sinHerramientas: "None yet.",
						nombre: "Name",
						nombrePlaceholder: "E.g: Shipment tracking",
						descripcion: "When to use it",
						descripcionPlaceholder: "Use when the customer wants to track a shipment",
						url: "Webhook URL",
						urlPlaceholder: "https://your-n8n.com/webhook/tracking",
						connection: "Data connection",
						sinConexion: "No connection · own URL",
						filters: "Fixed filters (optional)",
						filtersHelp: "Added to every query. E.g. select=text,metadata&limit=5 — keeps heavy columns and extra rows out.",
						nuevaTitulo: "New tool",
						editarTitulo: "Edit tool",
						guardar: "Save",
						source: "Data source",
						kind: "Tool type",
						kindDatabase: "Database · Supabase, PostgREST or another connection",
						kindWebhook: "HTTP / REST · its own URL (n8n, external API)",
						noConnections: "No connections yet. Create them in Automation → Data connections.",
						query: "SQL query",
						filter: "Filter (JSON)",
						filterHelp: "Empty returns the first documents. Use :name where a customer value goes, same as the parameters below.",
						queryHelp: "Read only. Customer data goes in as :name and is bound as a parameter, never concatenated.",
						cambiarOrigen: "Change source",
						columnsNoList: "Could not read the connection columns. Type them separated by commas.",
						columns: "Columns to fetch",
						columnsHelp: "Empty fetches all. Leave out heavy ones, like embedding vectors.",
						limit: "Max rows",
						searchMode: "Search type",
						searchText: "By text · matches what is spelled the same",
						searchVector: "Semantic · compares meaning",
						rpc: "Search function",
						rpcHelp: "The function that compares vectors, with the rpc/ prefix.",
						vectorParam: "Parameter turned into a vector",
						vectorParamHelp: "Must be named exactly like the function argument.",
						embeddingModel: "Embedding model",
						embeddingWarning: "The model must be the SAME one that loaded the table vectors. A mismatch does not error: it returns random results.",
						collection: "Collection",
						collectionHelp: "Available tables:",
						collectionNoList: "Could not read the connection listing. Type the table name.",
						url: "Webhook URL",
						headersConConexion: "Added to the connection ones. Usually left empty.",
						transporte: "Connection",
						metodo: "Method",
						headers: "Authentication (optional)",
						headersAyuda: "Only if the API requires a key. Use a read-only one.",
						parametros: "Data it sends",
						parametroNombrePlaceholder: "field_name",
						parametroDescripcionPlaceholder: "What it is. E.g.: tracking number, ID or phone",
						parametroFormatoLabel: "Format",
						parametroValorFijoPlaceholder: "Value that is always sent",
						parametroValorFijoAyuda: "If you fill this in, the model is never asked for this field: the system always sends it exactly as written here.",
						parametroAutoFillLabel: "Or fill with",
						parametroAutoFillAyuda: "The system fills it in on its own, without asking the model.",
						parametroAutoFillNinguno: "Nothing (the model fills it in)",
						parametroAutoFillTelefono: "Contact's phone number",
						parametroAutoFillNombre: "Contact's name",
						sectionWhatItDoes: "What it does",
						sectionWhatItDoesHelp: "The agent uses it when what you write in “When to use it” applies.",
						sectionWhere: "Where it queries",
						sectionDataHelp: "Each piece of data the tool sends in the query, and where it comes from.",
						colField: "Field",
						colSource: "Filled by",
						sourceAgent: "The agent (asks the customer)",
						sourceFixed: "A fixed value",
						sourceAutomatic: "Filled in automatically by the system",
						noData: "This tool does not send any data.",
						headerName: "Name",
						headerValue: "Value",
						addHeader: "Add header",
						agregarParametro: "Add field",
						agregar: "Add tool",
						agregarNueva: "Add new tool",
						editar: "Edit",
						guardar: "Save",
						cancelar: "Cancel",
						agregada: "Tool added",
						actualizada: "Tool updated",
						eliminada: "Tool deleted",
					},
				},
				success: "Prompt saved successfully",
				title: {
					add: "Add Prompt",
					edit: "Edit Prompt",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					discard: "Discard changes",
				},
			},
			prompts: {
				active: "On",
				inactive: "Off",
				activeHelp: "When off, the main agent transfers to an advisor instead of consulting this specialist.",
				title: "Prompt",
				empty: "No prompts yet.",
				tabs: {
					text: "Text",
					voice: "Call",
				},
				emptyTab: {
					text: "There are no text prompts yet.",
					voice: "There are no call prompts yet.",
				},
				unlinkedSpecialists: "Unlinked specialists",
				delete: "Delete",
				selectHint: "Pick an agent from the list to view and edit its prompt.",
				wrongTypeHint: "not for this channel",
				filterType: "Type",
				types: {
					all: "All",
					text: "Text",
					voice: "Call",
					specialist: "Specialist",
				},
				typeHelp: {
					text: "Handles chats: WhatsApp, web, Instagram, Facebook.",
					voice: "Handles phone calls and the voice avatar.",
					specialist: "Consulted by text and call prompts. Doesn't handle customers on its own.",
				},
				card: {
					sinCola: "No queue assigned",
					sinInstrucciones: "No instructions yet",
					especialistaDe: "Specialist of",
					sinPadres: "Not linked to any prompt",
					especialista: "specialist",
					especialistas: "specialists",
					herramienta: "tool",
					herramientas: "tools",
					avatarVoz: "Voice avatar",
					vozWhatsapp: "WhatsApp voice",
				},
				table: {
					agente: "Agent",
					departamento: "Department",
					modeloVoz: "Model and voice",
					tipo: "Type",
					resumen: "Summary",
					detalles: "Details",
					acciones: "Actions",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be undone!",
				},
				buttons: {
					add: "Add Prompt",
				},
			},
			contactModal: {
				title: {
					add: "Add contact",
					edit: "Edit contact",
				},
				form: {
					mainInfo: "Contact details",
					extraInfo: "Additional information",
					connectedInfo: "Available connection",
					name: "Name",
					number: "Whatsapp number",
					email: "Email",
					username: "WhatsApp username",
					usernameHelp: "Set by the customer in WhatsApp; updates automatically.",
					usernameManualHelp: "For identification only -- if they never messaged you, this won't let you start a conversation with them.",
					numberOrUsernameRequired: "Enter a phone number or a WhatsApp username",
					extraName: "Field name",
					extraValue: "Value",
				},
				representate: {
					title: "Representative",
					fieldLabel: "Write a representative",
					noOptions: "No users with that name found.",
				},
				buttons: {
					addExtraInfo: "Add information",
					okAdd: "Add",
					sendToCRM: "Send to CRM",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add queue",
					edit: "Edit queue",
					tabData: "Area Data",
					tabSchedules: "Business Hours",
					tabAssignment: "Team and assignment",
				},
				sections: {
					basics: "General",
					bot: "Automated attention",
					messages: "Messages",
					survey: "Satisfaction survey",
				},
				assignment: {
					autoAssignTitle: "Enable automatic assignment",
					autoAssignHelp: "Each new chat that reaches the department is assigned to the team member with the fewest open chats. In departments with AI, it is assigned only when the AI transfers.",
					offlineTitle: "Assign to offline users",
					offlineHelp: "When enabled, chats are also assigned to members who are not connected.",
					redistributeTitle: "Redistribute chats from unavailable users",
					redistributeHelp: "When a message arrives on a chat whose agent is offline, the chat moves to another connected team member.",
					agents: "Agents",
					searchAgent: "Search agent",
					noAgents: "No agents match the search.",
					apply: "Apply",
					columns: {
						name: "Name",
						email: "Email",
						member: "Member",
						memberHelp: "Belongs to this department: sees its chats and can attend them. When off, the department chats are not visible to them.",
						autoAssign: "Automatic assignment",
						autoAssignHelp: "Receives new chats automatically when the department automatic assignment is enabled. When off, they stay a member and can take chats manually, but none arrive on their own.",
					},
				},
				form: {
					name: "Name",
					color: "Color",
					greetingMessage: "Greeting Message",
					complationMessage: "Closing message",
					outOfHoursMessage: "After-hours message",
					ratingMessage: "Rating message",
					token: "API Token",
					orderQueue: "Bot queue order",
					integrationId: "Integration",
					botMode: "Department bot",
					botModeNone: "None",
					botModePrompt: "Prompt (AI)",
					botModeIntegration: "External integration (n8n, Typebot, Dialogflow)",
					queueGroup: "Queue group",
					none: "None",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					attach: "Attach File",
					saveSchedules: "Add",
				},
				toasts: {
					deleted: "File deleted successfully",
					queueSaved: "Area saved successfully",
					clickSaveToApply: "Click save to apply the changes",
				},
				flowPlaceholder: "Save the queue first to be able to configure the bot's option menu.",
			},
			queueFlowBuilder: {
				noMessage: "No message",
				rootTitle: "Main menu",
				rootSubtitle: "The bot shows these options to the customer",
				defaultOptionTitle: "New option",
				editTitle: "Edit option",
				toasts: {
					optionSaved: "Option saved",
					fileAttached: "File attached",
				},
				deleteModal: {
					title: "Delete option",
					messageWithChildren: "This option has sub-options that will be left orphaned. Delete anyway?",
					message: "Delete this option from the menu?",
				},
				buttons: {
					addOption: "Add option",
					organize: "Organize",
					organizeTooltip: "Automatically rearrange the tree",
					save: "Save",
					addSubOption: "Add sub-option",
					deleteOption: "Delete option",
				},
				form: {
					numberTooltip: "What the customer needs to type to choose this option",
					number: "Number",
					title: "Title",
					message: "Message the bot sends",
				},
				media: {
					attachedFile: "attached file",
					attach: "Attach a file",
					dropHint: "or drag a file here",
				},
			},
			userModal: {
				title: {
					add: "Add user",
					edit: "Edit user",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
					profile: "Profile",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			scheduleModal: {
				title: {
					add: "New Schedule",
					edit: "Edit Schedule",
				},
				form: {
					body: "Message",
					contact: "Contact",
					sendAt: "Schedule date",
					sentAt: "Sent date",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Edit",
					cancel: "Cancel",
				},
				success: "Scheduled successfully.",
			},
			tagModal: {
				title: {
					add: "New Tag",
					edit: "Edit Tag",
				},
				form: {
					name: "Name",
					color: "Color",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Edit",
					cancel: "Cancel",
				},
				success: "Tag saved successfully",
			},
			chat: {
				noTicketMessage: "Select a ticket to start chatting.",
			},
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			tickets: {
				toasts: {
					deleted: "The ticket you were on has been deleted.",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
					archived: { title: "Archived" },
				},
				search: {
					placeholder: "Search by name",
					ariaLabel: "Search tickets",
				},
				buttons: {
					showAll: "All",
				},
				myTickets: "My Chats",
				allTickets: "All chats",
				filters: {
					show: "Show filters",
					hide: "Hide filters",
				},
				unread: {
					showAll: "Show all",
					showUnreadOnly: "Show unread only",
				},
				newConversation: "New conversation",
			},
			transferTicketModal: {
				title: "Transfer Ticket",
				fieldLabel: "Type to search for users",
				fieldQueueLabel: "Transfer to a queue",
				fieldQueuePlaceholder: "Select a queue",
				noOptions: "No user found with this name",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
			},
			ticketsList: {
				pendingHeader: "Pending",
				assignedHeader: "Working on",
				favoriteHeader: "Favorite",
				botHeader: "ChatBot",
				noTicketsTitle: "Nothing here!",
				noTicketsMessage: "No tickets found with this status or search term.",
				buttons: {
					accept: "Accept",
					closed: "Finalizar",
					reopen: "Reabrir"
				},
			},
			newTicketModal: {
				title: "Create Ticket",
				fieldLabel: "Type to search for a contact",
				add: "Add",
				noSendableIdentity: "This contact has no number and never messaged you -- a ticket can't be opened yet.",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Connections",
					calls: "Calls",
					callHistory: "History",
					callMetrics: "Metrics",
					aiCosts: "Billing",
					aiReplies: "AI Audit",
					tickets: "Chats",
					contacts: "Contacts",
					queues: "Queues",
					api: "API",
					administration: "Administration",
					users: "Users",
					settings: "Settings",
					prompts: "AI Agents",
					dataSources: "Data connections",
					knowledge: "Knowledge base",
					queueIntegration: "Integrations",
					annoucements: "Announcements",
					campaigns: "Campaigns",
					chats: "Internal Chat",
					financeiro: "Billing",
					helps: "Help",
					messagesAPI: "API",
					quickMessages: "Quick Replies",
					schedules: "Schedules",
					tags: "Tags",
					templateMessage: "Templates",
					adCampaigns: "Ads",
					management: "Management",
					kanbanTags: "Tags Kanban",
					kanbanContacts: "Contacts Kanban",
					reports: "Reports",
					auditor: "Audit Log",
					activity: "Activity Log",
					analytics: "Analytics",
					automation: "Automation",
					company: "Company",
					campaignsList: "List",
					campaignsSettings: "Settings",
				},
				appBar: {
					user: {
						profile: "Profile",
						logout: "Logout",
					},
					language: {
						title: "Change language",
					},
				},
			},
			promptVersions: {
				title: "Version history",
				history: "History",
				open: "View this prompt's version history",
				empty: "No saved versions yet. One is created every time you save a change to the prompt.",
				current: "Current",
				columns: {
					version: "Version",
					date: "Date",
					note: "Reason",
				},
				compare: "Changes from v{{version}} to the current one",
				changes: "{{count}} different line(s)",
				noChanges: "Same as the current one",
				pick: "Pick a version to see what changed.",
				legend: "Green: added later · Red strikethrough: was in that version and was removed",
				close: "Close",
				restore: "Restore v{{version}}",
				confirmRestore: "Restore version {{version}}? The current prompt is kept in the history, so you can go back to it.",
				restored: "Version {{version}} was restored.",
				notePlaceholder: "Reason for the change (optional), e.g.: fixed the Elizabeth address",
			},
			promptCoach: {
				title: "Correct the agent",
				reply: "Agent reply",
				correctionLabel: "What went wrong or what should it have done?",
				correctionPlaceholder: "E.g.: it gave the Quito address when I asked about Elizabeth; it should have asked Oficinas about Elizabeth, New Jersey.",
				analyzing: "Analyzing the conversation and the prompt…",
				diagnosis: "What happened",
				target: "Change in",
				targetSelf: "this agent ({{name}})",
				targetSpecialist: "the {{name}} specialist",
				cancel: "Cancel",
				retry: "Back to the correction",
				analyze: "Propose change",
				applyDraft: "Apply to draft",
				saveSpecialist: "Save to {{name}}",
			},
			knowledge: {
				editHelp: "Compare what the PDF says with what the agent understood. Fix the right side if something does not match and remove extra rules.",
				imageNotice: "This text was read from an image in the PDF. Check it more carefully: letters or numbers can slip.",
				editTitle: "Review: {{section}}",
				editHelp: "Compare each rule with the PDF. If something does not match, fix it in the right column; remove the ones that are extra. When it is right, click \"Save and approve\".",
				inPdf: "In the PDF",
				agentWillKnow: "What the agent will know",
				organization: "Where it belongs (optional)",
				pathPlaceholder: "E.g.: Ecuador › Parcels › Taxes",
				removeRule: "Remove this rule",
				saveAndApprove: "Save and approve",
				entrySavedApproved: "Record saved and approved",
				promptTab: {
					whenToUse: "When this agent should look it up",
					whenToUsePlaceholder: "E.g.: When they ask about the story of Teresa and Jorge, its characters or what happens to them.",
					missingUsage: "Write when to use each enabled document.",
					unsaved: "Unsaved changes",
					tab: "Knowledge",
					title: "Documents this agent can look up",
					help: "Turn on the documents this agent can look up and write, for each one, when it should do it. Only published documents appear.",
					empty: "There are no published documents yet. Upload and publish them in the Knowledge base.",
					document: "Document",
					version: "Published version",
					rules: "Rules",
					use: "Use",
					saved: "Agent knowledge updated",
				},
				publish: {
					button: "Publish ({{count}} rules)",
					republish: "Publish again",
					unpublish: "Unpublish",
					title: "Publish to the knowledge base",
					summary: "{{count}} approved rules will be published. The {{agent}} agent will be able to look them up with the \"consultar_base_de_conocimiento\" tool, which is added automatically. Pending and rejected records are not published.",
					replaceNotice: "Replaces what was published from this document.",
					confirm: "Publish",
					publishing: "Publishing…",
					done: "{{count}} rules published",
					unpublished: "Document unpublished: the agent no longer uses it",
					banner: "Published: {{count}} rules · {{date}}",
					pendingChanges: "There are unpublished changes",
				},
				costLabel: "cost ${{cost}}",
				statusTabs: {
					pending: "Pending",
					approved: "Approved",
					rejected: "Rejected",
				},
				optional: "Optional",
				tagsPlaceholder: "Type and press Enter",
				title: "Knowledge base",
				uploadButton: "Upload PDF",
				uploadTitle: "Upload document",
				chooseFile: "Choose PDF file",
				name: "Name",
				namePlaceholder: "E.g. Services Manual (leave empty to use the file name)",
				uploadHint: "It is processed with your agents' OpenAI key, about $1 for a 60-page manual. Uploading a new version with the same name saves it as v2, v3… and the agents that use it pick it up automatically when it is published.",
				emptyState: {
					title: "Teach your agent what it needs to know",
					subtitle: "The knowledge base is the information the agent looks up to answer customers: rules, requirements, hours, policies. Choose how to start.",
					aiTitle: "Create with AI",
					aiText: "Tell it the topic or attach a manual. The AI asks you questions until every fact is clear and writes the text for you.",
					pdfTitle: "Upload a PDF",
					pdfText: "If you already have a clear, organized document, upload it and the AI turns it into rules for you to review.",
				},
				manual: {
					button: "Create with AI",
					title: "Write by hand",
					editTitle: "Edit text",
					namePlaceholder: "Document name, e.g. Rules US → Ecuador",
					startTitle: "What should the agent know?",
					startHint: "Write it in your own words or attach a manual. I will ask you questions until every fact is clear, and build the text for you.",
					writeMyself: "I'd rather write the text myself",
					draftTitle: "What the agent will know",
					draftEmpty: "It is still empty. Answer the assistant's questions and the text will build up here.",
					editHint: "One fact per line. Titles start with #. Each line must make sense on its own.",
					save: "Save and process",
					saving: "Saving…",
					saved: "Text saved. It is being processed.",
					source: "Written by hand",
					editText: "Edit text",
					inText: "In the text",
					assistantIntro: "Pick a topic, write your own or attach a manual (PDF or TXT) with the clip.",
					attachSource: "Attach a manual (PDF or TXT)",
					sourceGoal: "Build the information from the manual \"{{name}}\"",
					sourceTruncated: "{{name}} (too long: only the first part is used)",
					goalPlaceholder: "E.g. Each office's hours and closing days",
					answerPlaceholder: "Type your answer…",
					suggestions: {
						s1: "Office hours and closing days",
						s2: "Frequently asked customer questions",
						s3: "Requirements for a procedure",
						s4: "Claims and returns policies",
					},
				},
				upload: "Upload and process",
				uploading: "Uploading…",
				uploaded: "Document uploaded. It is being processed.",
				cancel: "Cancel",
				save: "Save",
				deleted: "Document deleted",
				deleteTitle: "Delete {{name}}?",
				deleteMessage: "The PDF and all its extracted records will be deleted. This cannot be undone.",
				empty: "No documents yet.",
				review: "Review",
				delete: "Delete",
				reprocess: "Process again",
				approveClean: "Approve the ones without alerts ({{count}})",
				approvedClean: "{{count}} records approved",
				approve: "Approve",
				reject: "Reject",
				undoReview: "Back to pending",
				edit: "Edit",
				entrySaved: "Record updated",
				rule: "Rule",
				rulesCount: "{{count}} rules",
				page: "p.",
				pagesCount: "{{count}} pages",
				reviewProgress: "{{approved}} of {{total}} approved",
				noCountry: "No country",
				noEntries: "No records match these filters.",
				verified: "Verified: the quote appears exactly in the PDF",
				notVerified: "Not verified: check this against the PDF",
				columns: {
					path: "Location in the document",
					tags: "Tags",
					section: "Section",
					name: "Name",
					version: "Version",
					status: "Status",
					review: "Review",
					alerts: "Alerts",
					cost: "Cost",
					date: "Date",
					actions: "Actions",
					country: "Country",
					content: "Content",
					pages: "Pages",
				},
				documentStatus: {
					processing: "Processing",
					review: "In review",
					failed: "Failed",
					published: "Published",
				},
				entryStatus: {
					pending: "Pending",
					approved: "Approved",
					rejected: "Rejected",
				},
				progress: {
					queued: "Queued…",
					reading: "Reading the document…",
					images: "Reading the images: {{done}} of {{total}}",
					outline: "Finding the sections by country…",
					extracting: "Extracting the information: {{done}} of {{total}} parts",
					validating: "Checking every fact against the document…",
				},
				summary: {
					total: "{{count}} records",
					withAlerts: "{{count}} with alerts",
					pending: "{{count}} pending",
					approved: "{{count}} approved",
					rejected: "{{count}} rejected",
				},
				report: {
					inconsistencies: "Contradictions found in the document",
					warnings: "Processing notices",
				},
				filters: {
					onlyAlertsCount: "With alerts ({{count}})",
					all: "All",
					search: "Search",
					onlyAlerts: "Only with alerts",
				},
				alerts: {
					QUOTE_NOT_FOUND: "The quote is not in the PDF",
					NUMBER_NOT_IN_SOURCE: "A number is not in the quote",
					IMAGE_ONLY: "Read from an image: check it",
					PAGE_OUT_OF_RANGE: "Invalid page",
				},
			},
			promptTestChat: {
				thinking: "Thinking…",
				usedTools: "Used {{names}}",
				sent: "Sent",
				returned: "Response",
				noResult: "(no response)",
				kinds: {
					specialist: "Specialist",
					webhook: "Tool",
					transfer: "Transfer",
				},
				voiceTypePlaceholder: "Type to it during the call (for example, a tracking number)…",
				discardedSilence: "(silence or noise: not answered)",
				discardedNoise: "(noise discarded: \"{{text}}\")",
				discardedKeywords: "(discarded, only keywords, likely a phantom: \"{{text}}\")",
				discardedDuringTool: "(ignored while consulting: \"{{text}}\")",
				connectionUsed: "Using the connection settings: {{name}}",
				correct: "Correct",
				coachApplied: "The correction was applied to the draft (not saved). Replay the conversation to test it and save if you like it.",
				coachSavedSpecialist: "A new version of {{name}} was saved. Replay the conversation to test it.",
				replay: "Replay conversation",
				silenceWarning: "Silence: asked whether the caller is still there.",
				silenceHangup: "Call ended: nobody answered after asking if they were still there.",
				maxDurationReached: "Call ended by the configured maximum duration.",
				title: "Test agent",
				newChat: "New chat",
				draft: "Unsaved draft",
				draftHelp: "You're testing the text currently in the editor, even if it hasn't been saved yet.",
				mode: {
					text: "Replies like a WhatsApp chat, with its real specialists and tools.",
					voice: "Replies like a phone call (as text), using the voice model.",
					specialist: "Asks the specialist directly, as if the main agent were consulting it.",
				},
				empty: "Type a message as if you were the customer. Transfers are simulated: no ticket is created.",
				saveFirst: "Save the agent to test it.",
				you: "Customer",
				agent: "Agent",
				silent: "(the agent didn't reply)",
				error: "(error: {{error}})",
				transferred: "The conversation was transferred to an agent (simulated).",
				hungUp: "The agent hung up the call (simulated).",
				placeholder: "Type your message…",
				endedPlaceholder: "The conversation ended. Start a new chat.",
				emptyVoice: "Press \"Call\" and speak as if you were the customer. Transfers are simulated.",
				voiceError: "There was an error in the test call.",
				voiceStartError: "Couldn't start the test call: {{error}}",
				status: {
					idle: "No call",
					connecting: "Connecting…",
					listening: "Listening",
					thinking: "Thinking…",
					speaking: "Speaking",
				},
				mute: "Mute",
				unmute: "Unmute",
				startCall: "Call",
				endCall: "Hang up",
				modeText: "Text",
				modeVoice: "Voice",
				voiceUnavailable: "specialists can only be tested by text",
				voiceHint: "Use headphones to avoid echo",
				enterHint: "Enter to send · Shift+Enter for a new line",
			},
			aiReviewBanner: {
				question: "The AI handled this chat before it reached you. Did it do well?",
				good: "Good",
				problem: "Had a problem",
				later: "Rate later",
				thanks: "Thanks! Your rating helps improve the AI.",
				dialogTitle: "What did the AI do wrong?",
				dialogHelp: "Pick the main reason. You can add a detail if you want.",
				comment: "Detail (optional)",
				commentPlaceholder: "E.g.: it gave the address of another office",
				cancel: "Cancel",
				send: "Send",
				reasons: {
					wrongInfo: "Gave wrong information",
					misunderstood: "Didn't understand the customer",
					lateTransfer: "Transferred too late",
					needlessTransfer: "Transferred unnecessarily",
					tone: "Inappropriate tone",
					other: "Other",
				},
			},
			aiAssistant: {
				dictate: "Dictate by voice",
				stopDictation: "Stop and write what I said",
				listening: "Listening… press the red button to finish",
				transcribing: "Writing what you said…",
				micDenied: "The microphone could not be used. Check the browser permission for this site.",
				editDraft: "Edit",
				doneEditing: "Done",
				restart: "Start over",
				thinking: "Thinking…",
				start: "Start",
				send: "Send",
			},
			promptBuilder: {
				createButton: "Create with AI",
				improveButton: "Improve with AI",
				createTitle: "Create agent with AI",
				improveTitle: "Improve agent with AI",
				apply: "Use this prompt",
				applied: "Prompt applied in the editor. Review it and save.",
				startTitle: "What does this agent have to do?",
				startHint: "Describe it in your own words. I will not agree with everything: if something is ambiguous, contradictory or not valid for an AI, I will tell you and leave it out until it is clear.",
				writeMyself: "I'd rather write the prompt myself",
				assistantIntro: "Tell me what you want to change or ask me to review the prompt. I will question every request until it is clear and stable.",
				goalPlaceholder: "E.g. An agent that books home package pickups",
				answerPlaceholder: "Type your answer…",
				draftTitle: "Agent prompt",
				draftEmpty: "It is still empty. Answer the questions and the prompt will build up here.",
				editHint: "You can fix it by hand. When done, use \"Use this prompt\" and then save in the editor.",
				suggestions: {
					s1: "An agent that answers frequent questions",
					s2: "An agent that books appointments",
					s3: "A specialist on a specific topic",
					review: "Review the current prompt and tell me what is wrong",
					shorter: "Make it shorter without losing rules",
					transfer: "Define clearly when to transfer to an agent",
				},
			},
			testing: {
				title: "Testing",
				tabs: {
					textCases: "Text test cases",
					callCases: "Call test cases",
					avatar: "Voice avatar",
				},
				common: {
					loading: "Loading…",
					loadingConnections: "Loading connections…",
					noPrompt: "This connection has no prompt assigned.",
					edit: "Edit",
					delete: "Delete",
					cancel: "Cancel",
					save: "Save",
				},
				hints: {
					webhookAuth: "The webhook rejected authentication. Check the URL in the prompt's Tools tab.",
					specialistApiKey: "Set the specialist's real API key in Prompts → that prompt → API key. Each specialist uses its own key, not the parent prompt's.",
					quota: "The OpenAI account exceeded its quota or rate limit. Check the balance at platform.openai.com.",
					timeout: "The webhook didn't answer in time. Test the URL directly and make sure it responds in under 10 seconds.",
					blockedUrl: "The URL points to a private network or localhost, which the backend can't reach. It must be a public URL or a tunnel.",
					serverError: "The webhook server failed. The problem is on that side, not in the prompt.",
				},
				trace: {
					sends: "sends",
					noParams: "(no parameters)",
					goesTo: "goes to",
					model: "model",
					error: "error",
					fix: "fix",
					returns: "returns",
					noAnswer: "(no answer)",
					raw: "raw · {{count}} characters",
					tool: "tool",
					webhook: "webhook",
					specialist: "specialist",
				},
				avatar: {
					states: {
						idle: "Idle",
						listening: "Listening",
						thinking: "Thinking",
						speaking: "Speaking",
						error: "Error",
					},
					sensitivity: {
						high: "Quiet",
						medium: "Normal",
						low: "Noisy",
					},
					noConnections: "There are no voice avatar connections yet. Create one in Connections → New connection → Avatar and set up its 3D model and prompt.",
					connection: "Connection to test",
					start: "Start",
					stop: "End",
					thresholdChip: "Threshold: {{value}}",
					disabled: "This connection is disabled.",
					frameTitle: "Avatar test call",
					startHint: "Press Start and the call opens right here. The microphone permission is requested inside this box.",
					legend: {
						listening: "Listening",
						speaking: "Avatar speaking",
						thinking: "Thinking",
						threshold: "Voice threshold",
					},
					metrics: {
						noise: "Background noise",
						noiseNote: "with nobody speaking",
						peak: "Your voice peak",
						peakNote: "p90 while speaking",
						echo: "Avatar echo",
						echoNote: "{{percent}}% of threshold",
						echoEmpty: "talk to it first",
						margin: "Voice/noise margin",
						marginNote: "under 4x is low",
						turns: "Detected turns",
						turnsNote: "silence cuts",
						avgTurn: "Average length",
						avgTurnNote: "of each of your turns",
					},
					echo: {
						high: "Echo detected: while the avatar speaks, its own voice reaches the microphone above the threshold. The avatar will interrupt itself. Use headphones, lower the speaker volume or raise the threshold.",
						edge: "Borderline echo: the avatar's voice reaches the microphone close to the threshold. In a slightly noisier room it may start interrupting itself.",
						none: "No relevant echo: what comes in while the avatar speaks stays well below the threshold.",
					},
					audioBlocked: "The browser blocked audio playback ({{reason}}). The avatar answers but you can't hear it. In Brave it's usually the autoplay shield: open the lion icon → Advanced settings → allow autoplay on this site.",
					audioBlockedLog: "the browser blocked audio playback ({{reason}})",
					unknown: "unknown",
					userTurnLog: "user turn → {{seconds}} s",
					agentTree: "Agent tree",
					whoAvatar: "avatar",
					whoYou: "you",
				},
				scenarios: {
					connection: "Connection",
					stopAll: "Stop",
					queued: "Queued",
					chatting: "Chatting",
					calling: "On call",
					step: "message {{current}} of {{total}}",
					runProgress: "Case {{position}} of {{total}} · {{title}}",
					runAll: "Run all",
					newCase: "New case",
					running: "Running…",
					evaluating: "Evaluating with AI…",
					passCount: "{{count}} passed",
					failCount: "{{count}} failed",
					passed: "Passed",
					failed: "Failed",
					automatic: "(automatic)",
					run: "Run",
					columns: {
						case: "Case",
						status: "Status",
					},
					empty: "There are no test cases yet. Create one with \"New case\": what the customer writes and what the AI should do.",
					noTextConnections: "There are no Sandbox connections. Create one in Connections → New connection → Sandbox and assign the prompt you want to test.",
					noCallConnections: "There are no phone system (SIP) connections. Create one in Connections and assign the call prompt you want to test.",
					viewConversation: "View conversation",
					copyDebug: "Copy the full detail of this conversation (to ask an AI what it thinks)",
					debugCopied: "Detail copied.",
					copyFailed: "Couldn't copy.",
					confirmDelete: "Delete the case \"{{title}}\"?",
					expectedLabel: "Expected:",
					showMore: "Show more",
					showLess: "Show less",
					notRunYet: "This case hasn't been run yet.",
					turn: "Turn {{number}}",
					customer: "Customer",
					aiReply: "AI reply",
					ranTool: "Ran this tool",
					ranTools: "Ran these tools",
					callTransferred: "(the call was already transferred to an agent)",
					chatTransferred: "(the conversation was already transferred to an agent)",
					callHungUp: "(the AI already hung up)",
					aiSilent: "(the AI said nothing)",
					noPromptReply: "(this connection has no prompt configured)",
					errorReply: "(error: {{error}})",
					evalFailed: "Couldn't evaluate automatically. Judge it manually.",
				},
				form: {
					newTitle: "New test case",
					editTitle: "Edit case",
					title: "Title",
					titlePlaceholder: "E.g. Asks about Miami and then Orlando",
					category: "Category",
					customerWrites: "The customer writes",
					customerWritesHint: "One message per box, in the order the customer sends them. The AI answers each one before the next.",
					firstMessagePlaceholder: "E.g. Where is the Miami office?",
					nextMessagePlaceholder: "Next customer message",
					addMessage: "Add another message",
					removeMessage: "Remove this message",
					aiShould: "The AI should",
					aiShouldHint: "What the AI has to do or say for the case to pass. Another AI judges it with this, so be specific.",
					aiShouldPlaceholder: "E.g. Give the Miami address, and when asked about Orlando say there is no office there, without transferring.",
					moreOptions: "More options",
					phone: "Customer phone (optional)",
					phonePlaceholder: "Empty = a made-up test number is used",
					phoneHelpText: "If the case depends on real data (tracking by phone, for example), enter a real number so the search finds something real.",
					phoneHelpCall: "This is the number the customer \"calls\" from. If the case depends on real data (tracking by phone, for example), enter a real number.",
				},
				filters: {
					search: "Search a case…",
					all: "All ({{count}})",
					fail: "Failed ({{count}})",
					pass: "Passed ({{count}})",
					pending: "Not run ({{count}})",
					noResults: "No case matches the search or filter.",
				},
				groups: {
					uncategorized: "Uncategorized",
					summary: "{{passed}} of {{total}} passed",
					failedCount: "{{count}} failed",
					run: "Run group ({{count}})",
					runFiltered: "Run {{count}} filtered",
				},
				debug: {
					case: "Case: {{title}}",
					expected: "Expected: {{expected}}",
					verdict: "Verdict: {{verdict}}",
					verdictAuto: "Verdict (automatic): {{verdict}}",
					reason: "Reason: {{reason}}",
					turn: "--- Turn {{number}} ---",
					customer: "Customer: {{text}}",
					ai: "AI: {{text}}",
					toolsCalled: "Tools called in this turn:",
					result: "Result",
					noTools: "(No tool was called in this turn.)",
					question: "What do you think, is this right or wrong, and why?",
				},
			},
			queueIntegration: {
				title: "Integrations",
				table: {
					id: "ID",
					type: "Type",
					name: "Name",
					projectName: "Project Name",
					language: "Language",
					lastUpdate: "Last Update",
					actions: "Actions",
				},
				buttons: {
					add: "Add Project",
				},
				searchPlaceholder: "Search...",
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? This action cannot be undone! It will be removed from linked queues and connections.",
				},
			},
			notifications: {
				noTickets: "No notifications.",
			},
			plans: {
				form: {
					name: "Name",
					users: "Users",
					connections: "Connections",
					campaigns: "Campaigns",
					schedules: "Schedules",
					enabled: "Enabled",
					disabled: "Disabled",
					clear: "Clear",
					delete: "Delete",
					save: "Save",
					no: "No",
					yes: "Yes",
					money: "$",
				},
			},
			auditor: {
				title: "Audit Log",
				filters: {
					from: "From",
					to: "To",
					filter: "Filter",
				},
				kpis: {
					totalAudits: "Total audits",
					agentsAudited: "Agents audited",
					aiClients: "AI clients",
					avgUser: "Avg. user",
					avgAi: "Avg. AI",
					userAuditsSuffix: "user audits",
					aiAuditsSuffix: "AI audits",
				},
				distribution: {
					title: "Global distribution",
					verySatisfied: "Very sat.",
					satisfied: "Sat.",
					neutral: "Neutral",
					unsatisfied: "Unsat.",
					veryUnsatisfied: "Very unsat.",
				},
				classification: {
					spam: "Spam 🚫",
					noReply: "No reply 📵",
					escalated: "Escalated ⚠️",
					recurring: "Recurring 🔁",
					unclassified: "Unclassified ❓",
					noRating: "No rating",
				},
				tabs: {
					user: "User",
					ai: "AI",
				},
				table: {
					agent: "Agent",
					client: "Client",
					rating: "Rating",
					auditsTickets: "Audits / Tickets",
					type: "Type",
					lastAudit: "Last audit",
					view: "View",
					ticketsBtn: "Tickets",
					aiChip: "AI",
					empty: "No audits in the selected period",
				},
			},
			callCommon: {
				outcomes: {
					hangup: "Hung up",
					socketError: "Call error",
					noPrompt: "Rejected (no voice configured)",
					serverError: "Server error",
					transferred: "Transferred to an agent",
				},
				sentiments: {
					verySatisfied: "Very satisfied",
					satisfied: "Satisfied",
					dissatisfied: "Dissatisfied",
					veryDissatisfied: "Very dissatisfied",
				},
				transferStatus: {
					answer: "Answered",
					busy: "Busy",
					noAnswer: "No answer",
					cancel: "Cancelled",
					congestion: "Congestion / dropped line",
					chanUnavail: "Number unavailable",
				},
				transferResult: {
					unconfirmed: "Transferred (unconfirmed)",
					answered: "Transferred and answered",
					notAnswered: "Not answered ({{status}})",
				},
			},
			callHistory: {
				filterAll: "All",
				auditFilter: "Audit",
				auditAudited: "Audited",
				auditPending: "Not audited",
				auditedBy: "Audited by {{name}}",
				title: "History",
				allDates: "All dates",
				dateFrom: "From",
				dateTo: "To",
				clear: "Clear",
				apply: "Apply",
				filters: "Filters",
				actions: "Actions",
				exportCsv: "Export CSV",
				outcome: "Outcome",
				allOutcomes: "All",
				fromLabel: "From (caller)",
				toLabel: "To (dialed number)",
				pageInfo: "Page {{page}} of {{totalPages}} · Total: {{total}}",
				perPage: "{{count}} / page",
				columns: {
					date: "Date",
					duration: "Duration",
					cost: "Cost",
					direction: "Direction",
					from: "From",
					to: "To",
					connection: "Connection",
					resolved: "Resolved?",
					sentiment: "Sentiment",
					outcome: "Outcome",
				},
				inbound: "Inbound",
				yes: "Yes",
				no: "No",
				emptyNoFilters: "No calls recorded yet.",
				emptyFiltered: "No calls match these filters.",
			},
			callMetrics: {
				title: "Metrics",
				apply: "Apply",
				periods: {
					today: "Today",
					yesterday: "Yesterday",
					thisWeek: "This week",
					lastWeek: "Last week",
					thisMonth: "This month",
					lastMonth: "Last month",
					custom: "Custom",
				},
				tiles: {
					calls: "Calls",
					successRate: "Success rate",
					resolvedRate: "Resolved by AI",
					cost: "Estimated cost",
					knownContacts: "From known contacts",
				},
				tooltips: {
					successRate: "Of all calls, how many ended by hanging up normally -- with no technical error and not rejected for missing a configured voice. It doesn't measure whether the customer was satisfied, only that the call itself didn't fail.",
					resolvedRate: "Of the calls the AI analyzed after hanging up (reading the transcript), in how many it considers it truly resolved or moved forward what the customer needed. It's a real quality indicator, not just that the call wasn't cut off.",
				},
				callsPerDayTitle: "Calls per day · {{range}} ({{days}} days)",
				legend: {
					resolved: "Resolved by AI",
					notResolved: "Not resolved",
					notAnalyzed: "Not analyzed",
				},
				emptyNoCallsInRange: "No calls in this range yet.",
				transfersTitle: "Transfers: {{count}}",
				transferLabels: {
					answered: "Answered",
					notAnswered: "Not answered",
				},
				emptyNoTransfers: "No transfers in this range.",
				sentimentTitle: "Customer satisfaction",
				satisfiedCenterLabel: "Satisfied",
				emptyNoAnalyzed: "No calls analyzed yet.",
				durationTitle: "Call duration",
				specialistTitle: "Which specialist handled it",
				noSpecialist: "No specialist (direct transfer)",
				emptyNoData: "No data yet.",
			},
			whatsappManager: {
				title: "WhatsApp Analytics",
				cards: {
					sent: "Sent",
					pending: "Pending",
					failed: "Failed",
					multimedia: "Multimedia",
				},
				filters: {
					from: "From",
					to: "To",
					connection: "Connection",
					number: "Number",
					numberPlaceholder: "e.g. +593...",
					status: "Status",
					priority: "Priority",
					content: "Message content",
					contentPlaceholder: "Search in the text...",
					all: "All",
					today: "Today",
					last7: "Last 7 days",
					last30: "Last 30 days",
					clear: "Clear",
					apply: "Apply filters",
				},
				status: {
					sent: "Sent",
					pending: "Pending",
					failed: "Failed",
				},
				priority: {
					high: "High",
					medium: "Medium",
					low: "Low",
				},
				table: {
					origin: "Origin",
					destination: "Destination",
					status: "Status",
					priority: "Priority",
					date: "Date",
					message: "Message",
					actions: "Actions",
					viewDetails: "View details",
					retry: "Retry sending",
				},
				empty: {
					title: "No results with the current filters",
					subtitle: "Adjust the filters or try “Last 30 days”.",
				},
				detail: {
					title: "Delivery details",
					number: "Number",
					author: "Author",
					whatsapp: "WhatsApp",
					date: "Date",
					status: "Status",
					priority: "Priority",
					detail: "Detail",
					message: "Message",
					noError: "No error detail.",
					unknown: "Unknown",
					close: "Close",
					retry: "Retry",
				},
				toasts: {
					retrying: "Retrying delivery…",
					retryError: "Could not retry the delivery.",
					loadError: "Error fetching data.",
				},
			},
			messagesAPI: {
				title: "API",
				textMessage: {
					number: "Number",
					body: "Message",
					token: "Registered token",
				},
				mediaMessage: {
					number: "Number",
					body: "File name",
					media: "Files",
					token: "Registered token",
				},
			},
			quickMessages: {
				title: "Quick Replies",
				buttons: {
					add: "New Quick Reply",
				},
				dialog: {
					shortcode: "Shortcut",
					message: "Reply",
				},
			},
			templateMessage: {
				title: "Message Templates",
				buttons: {
					add: "Add New Template",
				},
				dialog: {
					name: "Name",
					status: "Status",
					message: "Message",
					language: "Language",
					addVariable: "Add Variable",
				},
			},
			contactLists: {
				title: "Contact Lists",
				table: {
					name: "Name",
					contacts: "Contacts",
					isvalidated: "Valid",
					isNotValidated: "Invalid",
					actions: "Actions",
				},
				buttons: {
					add: "New List",
				},
				dialog: {
					name: "Name",
					company: "Company",
					okEdit: "Edit",
					okAdd: "Add",
					add: "Add",
					edit: "Edit",
					cancel: "Cancel",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					deleted: "Record deleted",
				},
			},
			contactListItems: {
				title: "Contacts",
				searchPlaceholder: "Search...",
				buttons: {
					add: "New",
					lists: "Lists",
					import: "Import",
				},
				dialog: {
					name: "Name",
					number: "Number",
					whatsapp: "Whatsapp",
					email: "E-mail",
					okEdit: "Edit",
					okAdd: "Add",
					add: "Add",
					edit: "Edit",
					cancel: "Cancel",
				},
				table: {
					name: "Name",
					number: "Number",
					whatsapp: "Whatsapp",
					email: "E-mail",
					actions: "Actions",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
					importMessage: "Do you want to import contacts from this spreadsheet?",
					importTitlte: "Import",
				},
				toasts: {
					deleted: "Record deleted",
				},
			},
			campaigns: {
				title: "Campaigns",
				searchPlaceholder: "Search...",
				buttons: {
					add: "New Campaign",
					contactLists: "Contact Lists",
				},
				table: {
					name: "Name",
					whatsapp: "Connection",
					contactList: "Contact List",
					status: "Status",
					scheduledAt: "Scheduled for",
					completedAt: "Completed",
					confirmation: "Confirmation",
					actions: "Actions",
				},
				dialog: {
					new: "New Campaign",
					update: "Edit Campaign",
					readonly: "View",
					form: {
						name: "Name",
						message1: "Message 1",
						message2: "Message 2",
						message3: "Message 3",
						message4: "Message 4",
						message5: "Message 5",
						confirmationMessage1: "Confirmation message 1",
						confirmationMessage2: "Confirmation message 2",
						confirmationMessage3: "Confirmation message 3",
						confirmationMessage4: "Confirmation message 4",
						confirmationMessage5: "Confirmation message 5",
						messagePlaceholder: "Message content",
						whatsapp: "Connection",
						status: "Status",
						scheduledAt: "Scheduled for",
						confirmation: "Confirmation",
						timezone: "Time zone",
						template: "Template",
						contactList: "Contact List",
					},
					buttons: {
						add: "Add",
						edit: "Update",
						okadd: "Ok",
						cancel: "Cancel",
						restart: "Restart",
						close: "Close",
						attach: "Attach Files",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					success: "Operation completed successfully",
					cancel: "Campaign cancelled",
					restart: "Campaign restarted",
					deleted: "Record deleted",
				},
			},
			announcements: {
				title: "Announcements",
				searchPlaceholder: "Search...",
				buttons: {
					add: "New Announcement",
					contactLists: "Announcement Lists",
				},
				table: {
					priority: "Priority",
					title: "Title",
					text: "Text",
					mediaName: "Files",
					status: "Status",
					actions: "Actions",
				},
				dialog: {
					edit: "Edit Announcement",
					add: "New Announcement",
					update: "Update Announcement",
					readonly: "View Only",
					form: {
						priority: "Priority",
						title: "Title",
						text: "Text",
						mediaPath: "Files",
						status: "Status",
					},
					buttons: {
						add: "Add",
						edit: "Update",
						okadd: "Ok",
						cancel: "Cancel",
						close: "Close",
						attach: "Attach files",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					success: "Operation completed successfully",
					deleted: "Record deleted",
				},
			},
			campaignsConfig: {
				title: "Campaign Settings",
			},
			helps: {
				general: "General",
				overline: "Help · {{section}}",
				counter: "Video {{current}} of {{total}}",
				playing: "Playing",
				previous: "Previous",
				next: "Next",
				noVideo: "This topic has no video.",
				empty: "There are no help videos yet.",
				title: "Help Center",
			},
			schedules: {
				title: "Schedules",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this schedule?",
					deleteMessage: "This action cannot be undone.",
				},
				table: {
					contact: "Contact",
					body: "Message",
					sendAt: "Scheduled for",
					sentAt: "Sent at",
					status: "Status",
					actions: "Actions",
				},
				buttons: {
					add: "New Schedule",
					retry: "Retry",
				},
				toasts: {
					deleted: "Schedule successfully deleted.",
					retry: "Schedule re-queued for sending.",
				},
			},
			tags: {
				title: "Tags",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this tag?",
					deleteMessage: "This action cannot be undone.",
				},
				table: {
					name: "Name",
					color: "Color",
					tickets: "Records",
					actions: "Actions",
				},
				buttons: {
					add: "New Tag",
				},
				toasts: {
					deleted: "Tag deleted successfully.",
				},
			},
			uploads: {
				titles: {
					titleUploadMsgDragDrop: "DRAG AND DROP FILES IN THE FIELD BELOW",
					titleFileList: "File list",
				},
			},
			queues: {
				title: "Queues",
				table: {
					name: "Name",
					color: "Color",
					greeting: "Greeting message",
					actions: "Actions",
					orderQueue: "Bot queue order",
					group: "Group",
					automation: "Automation",
					automationPrompt: "AI",
					automationIntegration: "Integration",
					rating: "Survey",
					ratingOn: "Yes",
					ratingOff: "No",
				},
				buttons: {
					add: "Add Queues",
					manageGroups: "Queue groups",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
				},
			},
			closeReasonModal: {
				categories: {
					title: "Analysis categories",
					name: "Category name",
					none: "No category",
				},
				title: "Close reasons",
				form: {
					name: "Reason name",
				},
				buttons: {
					add: "Add",
					close: "Close",
				},
				empty: "No reasons yet. Create the first one above.",
				note: "Deactivating a reason removes it from the close dialog but keeps it, so historical reports keep working. Delete it only if it was never used.",
				toasts: {
					created: "Reason created",
					updated: "Reason updated",
					deleted: "Reason deleted",
				},
				confirmDelete: {
					title: "Delete reason",
					message: "Are you sure? If it was already used in past closures, deactivating is better: deleting makes those closures lose the reference.",
				},
			},
			queueGroupModal: {
				title: "Queue groups",
				form: {
					name: "Group name",
				},
				buttons: {
					add: "Add",
					close: "Close",
				},
				empty: "No groups yet. Create the first one above.",
				queues: "queue(s)",
				toasts: {
					created: "Group created",
					updated: "Group updated",
					deleted: "Group deleted",
				},
				confirmDelete: {
					title: "Delete group",
					message: "Are you sure? The queues in this group are NOT deleted: they become ungrouped and you can reassign them anytime.",
				},
			},
			queueSelect: {
				inputLabel: "Queues",
			},
			users: {
				title: "Users",
				table: {
					name: "Name",
					email: "Email",
					profile: "Profile",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
				},
				toasts: {
					deleted: "User deleted sucessfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"All user data will be lost. Users' open tickets will be moved to queue.",
				},
			},
			settings: {
				success: "Settings saved successfully.",
				title: "Settings",
				settings: {
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
				},
				tabs: {
					options: "Options",
					schedules: "Schedules",
					companies: "Companies",
					plans: "Plans",
					helps: "Help",
					contactStatus: "Contact statuses",
					openai: "OpenAI",
					metaAds: "Ads (Meta)",
					metaApi: "Meta API",
					googleAds: "Ads (Google)",
					asterisk: "Phone system",
					googleCalendar: "Google Calendar",
					attention: "Customer service",
				},
				attention: {
					hours: {
						cardTitle: "Business hours",
						cardSubtitle: "Outside these hours the customer gets an automatic notice.",
						mode: {
							title: "Apply hours",
							disabled: "No hours",
							company: "Whole company",
							queue: "By department",
							help: {
								disabled: "Service at any time; no out-of-hours notice is sent.",
								company: "A single schedule for every department.",
								queue: "Each department has its own hours and message.",
							},
						},
						day: "Day",
						status: {
							title: "Service",
							hours: "Set hours",
							closed: "Closed",
							allDay: "24 hours",
						},
						from: "From",
						to: "To",
						days: {
							monday: "Monday",
							tuesday: "Tuesday",
							wednesday: "Wednesday",
							thursday: "Thursday",
							friday: "Friday",
							saturday: "Saturday",
							sunday: "Sunday",
						},
												fixErrors: "Check the days marked in red.",
						companyMessageHint: "The out-of-hours message comes from each connection (WhatsApp > Messages).",
						queueHint: "Each department sets its own hours and out-of-hours message. A department without hours is served at any time.",
						noQueues: "There are no departments yet.",
						queueTable: {
							queue: "Department",
							days: "Hours",
							message: "Out-of-hours message",
							summary: "{{hours}} with hours · {{closed}} closed",
							noSchedule: "Any time",
							missing: "Message missing",
							yes: "Yes",
						},
						queueDialogTitle: "Hours for {{name}}",
						outOfHoursMessage: "Out-of-hours message",
						outOfHoursHelp: "Sent when the customer writes outside this department's hours.",
						messageRequired: "Without this message the hours have no effect.",
						edit: "Edit",
						unsaved: "Unsaved changes",
						cancel: "Cancel",
						save: "Save",
						saved: "Hours saved.",
					},
					survey: {
						cardTitle: "Satisfaction survey",
						cardSubtitle: "Survey the customer receives when the chat is resolved.",
						configure: "Configure",
						status: {
							disabled: "Disabled",
							company: "Active for the whole company",
							queue: "Active by department",
						},
						summary: {
							comment: "Asks for a comment on ratings {{rates}}",
							customThanks: "{{count}} custom message(s) by rating",
							interactive: "Interactive list on the official WhatsApp API",
						},
						modalTitle: "Configure Satisfaction Survey",
						modalSubtitle: "Survey sent to the contact when the chat is resolved.",
						queueSubtitle: "Survey for the {{name}} department.",
						queueEnabled: {
							title: "Send survey in this department",
							help: "When a conversation in this department is closed, the customer receives the 1 to 5 survey.",
						},
						queueButton: "Configure survey",
						queueSaveFirst: "Save the department to configure its survey.",
						queueSends: "Sends survey",
						queueNotSends: "Does not send survey",
						unsaved: "Unsaved changes",
						enabled: {
							title: "Enable satisfaction survey",
							help: "When a conversation is closed, the customer receives a survey to rate the service from 1 to 5.",
						},
						scope: {
							title: "Apply to",
							help: "By department: each department decides whether to send it and has its own messages.",
							company: "Whole company",
							queue: "By department",
						},
						perDepartmentHint: "Each department has its own survey. Configure it here or from the department form.",
						queueTable: {
							queue: "Department",
							sends: "Sends survey",
							settings: "Messages",
							yes: "Yes",
							no: "No",
							customized: "Customized",
							defaults: "Default",
							empty: "There are no departments yet.",
						},
						autoClose: {
							title: "Send on automatic resolution",
							help: "Also send the survey when the chat is resolved automatically due to inactivity.",
						},
						interactiveList: {
							title: "Send as interactive list",
							help: "On the official WhatsApp API the survey is sent as a list to pick the rating. Other channels receive it as text.",
						},
						requestMessage: "Request message",
						requestHelp: "The 1 to 5 options are added below the message automatically.",
						thanksMessage: "Thank-you message (default)",
						askComment: {
							title: "Ask for a comment",
							help: "After the numeric rating, ask the customer for an optional comment.",
						},
						commentTimeout: {
							title: "Comment time limit",
							badge: "Single",
							help: "Applies to every rating. If the customer replies later, the message starts a new conversation.",
							unit: "min",
						},
						commentMessage: "Comment request message",
						customThanks: {
							title: "Custom message by rating",
							help: "Send a message other than the default depending on the contact's rating.",
						},
						customMessage: "Custom message",
						addRange: "Add range",
						noComment: "Not asked for a comment:",
						defaultThanks: "Use the default message:",
						rangeHint: "Tap the ratings to include them in this range. Locked ones already belong to another range.",
						lockedRate: "This rating is already in another range",
						deleteRange: "Delete range",
						required: "Required field",
						emptyRange: "Select at least one rating",
						variablesHint: "You can use {{name}} for the contact's name.",
						format: {
							bold: "Bold",
							italic: "Italic",
							strike: "Strikethrough",
							emoji: "Emoji",
						},
						cancel: "Cancel",
						save: "Save",
						saved: "Survey saved.",
						fixErrors: "Check the fields marked in red.",
					},
				},
				phoneSystemTabs: {
					connection: "Connection",
					callRecords: "Call records (CDR)",
				},
				googleAds: {
					account: {
						title: "Google Ads account",
						subtitle: "Connect the company's Google Ads account to bring impressions, clicks and cost for each campaign into the Ads report.",
						notConfigured: "Google Ads isn't configured on the server yet (GOOGLE_ADS_CLIENT_ID and GOOGLE_ADS_CLIENT_SECRET).",
						connectHint: "Sign in with the Google account that manages your ads. Only read access to reports is used.",
						connect: "Connect with Google Ads",
						connected: "Google account connected",
						connectError: "The Google Ads connection couldn't be completed",
						missingScope: "You didn't check the Google Ads permission on Google's screen. Disconnect, connect again and check the “See, edit, create and delete your Google Ads accounts and data” box.",
						notAdsUser: "The connected Google account has no access to any Google Ads account. Add it as a user in Google Ads (Admin → Access and security) and reload, or disconnect and connect with the account that manages your ads.",
						pickHint: "Connected as {{email}}. Pick the ad account to sync.",
						adAccount: "Ad account",
						pickPlaceholder: "Pick an account",
						loadingAccounts: "Loading accounts…",
						noAccounts: "No active ad accounts found for this Google user.",
						accountsError: "Google replied: {{error}}",
						reloadAccounts: "Reload accounts",
						disconnectWith: "Disconnect {{email}}",
						useAccount: "Use this account",
						cancel: "Cancel",
						googleAccount: "Google account",
						lastSync: "Last sync",
						never: "Never",
						autoSync: "Syncs automatically every 6 hours.",
						syncNow: "Sync now",
						synced: "{{count}} campaigns synced",
						syncError: "The last sync failed: {{error}}",
						changeAccount: "Change account",
						disconnect: "Disconnect",
						disconnected: "Google Ads disconnected",
						disconnectTitle: "Disconnect Google Ads",
						disconnectConfirm: "Metrics will stop syncing. Campaigns and tickets already recorded are kept.",
					},
					forms: {
						title: "Lead forms",
						subtitle: "Receives leads from Google Ads lead forms: creates the contact, opens the ticket on the chosen connection and records it in the Ads report.",
						howTo: "How do I connect it in Google Ads?",
						step1: "Save this configuration first.",
						step2: "In Google Ads, open the campaign and go to Assets → Lead forms. Create one or edit an existing one.",
						step3: "Under Lead delivery options → Webhook integration, paste the Webhook URL and the Key below.",
						step4: "Click Send test data: a new ticket marked \"Google Ads · Campaña … (prueba)\" should appear.",
						step5: "The form must ask for the phone number: without a phone the chat can't be opened and the lead is discarded.",
						cloudNote: "If the connection is WhatsApp Cloud (official API), the first message to the lead must be an approved template.",
						sectionGoogle: "Data to paste in Google Ads",
						sectionDestination: "Where the lead lands",
						webhookUrl: "Webhook URL",
						webhookUrlHelp: "Must be the public (https) URL of the backend.",
						key: "Key",
						keyHelp: "Goes in the webhook Key field in Google Ads.",
						connection: "Connection",
						connectionHelp: "The agent writes to the lead from this WhatsApp.",
						defaultConnection: "Default connection",
						queue: "Queue",
						queueHelp: "Optional. If none is chosen, the ticket has no queue.",
						noQueue: "No queue",
						copy: "Copy",
						copied: "Copied",
						copyError: "Couldn't copy",
						regenerate: "Generate new key",
						regenerated: "New key generated. Save it and update it in Google Ads too.",
						saved: "Google Ads configuration saved",
						save: "Save",
					},
					links: {
						campaignLabel: "Google Ads campaign",
						campaignHelp: "Links the link to the campaign so its cost is matched with the tickets it brings.",
						campaignEmpty: "Connect the Google Ads account to pick a campaign.",
						noCampaign: "No campaign",
						campaignPaused: "(paused)",
						title: "WhatsApp links for Google Ads",
						subtitle: "Each link carries a code in the message. When the customer writes with that code, the ticket is marked with the campaign and shows up in the Ads report. Paste the link as the ad's final URL.",
						newLink: "New link",
						name: "Name",
						code: "Code",
						phone: "Number",
						message: "Message",
						queue: "Queue",
						actions: "Actions",
						empty: "No links yet. Create one for each campaign you want to tell apart.",
						copyLink: "Copy link",
						linkCopied: "Link copied",
						copyError: "Couldn't copy",
						edit: "Edit",
						delete: "Delete",
						newTitle: "New link",
						editTitle: "Edit link",
						nameLabel: "Campaign name",
						namePlaceholder: "Summer campaign",
						nameHelp: "This is how it shows in the ticket and in the Ads report.",
						phoneLabel: "WhatsApp number",
						phoneHelp: "With country code, no + or spaces.",
						messageLabel: "Prefilled message",
						messageHelp: "The code is added automatically at the end of the message.",
						queueHelp: "Optional. If the ticket has no agent, it moves to this queue.",
						noQueue: "No queue",
						previewLabel: "This is what the customer will send",
						previewHint: "The code is generated when you save.",
						defaultMessage: "Hi, I'd like more information",
						cancel: "Cancel",
						save: "Save",
						created: "Link created",
						updated: "Link updated",
						deleted: "Link deleted",
						deleteTitle: "Delete link",
						deleteConfirm: "\"{{name}}\" ({{code}}) will be deleted. Tickets that already arrived through this link keep their record, but new messages with that code will no longer be marked.",
					},
				},
				optionsTab: {
					brandColor: "Brand color",
					brandColorHelp: "Report header",
					logo: "Logo",
					logoHelp: "PNG or JPG. Shown in the panel and in reports.",
					logoDrop: "Drag or click to change the logo",
					slaTitle: "Time targets (minutes)",
					slaFirstReply: "First reply",
					slaWait: "Wait until picked up",
					slaHandle: "Handling until closed",
					slaHelp: "The dashboard marks them green or red against these.",
					updating: "Updating...",
					sections: {
						appearance: {
							title: "Appearance",
							subtitle: "The logo and color used to identify your company in reports and the panel.",
						},
						botBehavior: {
							title: "Bot behavior",
							subtitle: "How the chatbot replies and what messages it handles.",
						},
						serviceAndSla: {
							title: "Service & time targets (SLA)",
							subtitle: "Rating rules, calls, and the time targets the dashboard marks green or red against.",
						},
						tickets: {
							title: "Tickets",
							subtitle: "Activity log and the close reasons available to agents.",
						},
					},
					ratings: {
						label: "Ratings",
						disabled: "Disabled",
						enabled: "Enabled",
						queue: "Manage by Department",
						company: "Manage by Company",
						help: "By Department: each department decides in its own settings. By Company: always asked, the same for all.",
					},
					scheduleType: {
						label: "Schedule Management",
						disabled: "Disabled",
						queue: "Manage by Department",
						company: "Manage by Company",
						help: "Who defines business hours: nobody (disabled), each department separately, or one set for the whole company.",
					},
					ignoreGroupMsgs: {
						label: "Ignore Group Messages",
						disabled: "Disabled",
						enabled: "Enabled",
						help: "When enabled, messages coming from a WhatsApp group don't create tickets.",
					},
					activityLog: {
						manageReasons: "Close reasons",
						manageReasonsHelp: "The reasons an agent picks when closing a ticket.",
						manage: "Manage",
						label: "Activity Log",
						disabled: "Disabled",
						enabled: "Enabled",
						help: "When enabled, agent actions on tickets are kept in a history.",
					},
					callType: {
						label: "Accept Calls",
						disabled: "Don't Accept",
						enabled: "Accept",
						help: "When set to \"Don't Accept\", incoming calls are rejected automatically.",
					},
					chatbotType: {
						label: "Chatbot Type",
						text: "Text",
						button: "Button",
						list: "List",
						help: "How the bot's menu options are shown to the customer.",
					},
					ticketFieldsTab: "Ticket Type Field Settings",
					infoType: "Information Type",
					valueLabel: "Value",
					newButton: "New",
					saveChanges: "Save Changes",
				},
			},
			messagesList: {
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Type a message",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				signMessage: "Sign",
			},
			contactDrawer: {
				header: "Contact details",
				buttons: {
					edit: "Edit contact",
					sendToCRM: "Send to CRM",
				},
				extraInfo: "Other information",
				connectedInfo: "Connected Info",
				viewExternalProfile: "View Profile"
			},
			ticketOptionsMenu: {
				delete: "Delete",
				transfer: "Transfer",
				block: "Block",
				schedule: "Schedule",
				registerAppointment: "Contact notes",
				appointmentsModal: {
					title: "Contact Note",
					textarea: "Note",
					placeholder: "Enter the information you want to record here",
				},

				confirmationModal: {
					title: "Delete ticket #",
					titleFrom: "from contact ",
					message: "Attention! All ticket's related messages will be lost.",
				},
				confirmationModalBlock: {
					title: "Do you want to block ticket #",
					titleFrom: "from contact ",
					message: "Attention! You won't be able to unblock this contact for now.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				delete: "Delete",
				reply: "Reply",
				confirmationModal: {
					title: "Delete message?",
					message: "This action cannot be reverted.",
				},
			},
			facebookComment: {
				pending: "This comes from a comment on a post. You can send 1 private message, text only, until {{deadline}}. If they reply, it continues as a normal chat.",
				waiting: "You already sent the private message. You can write again once the person replies.",
				expired: "More than 7 days have passed since the comment. A private reply is no longer possible.",
				viewPost: "View post",
			},
			metaGraphVersion: {
				title: "Meta API version",
				subtitle: "Graph API version and Meta apps used by the whole platform (Messenger, Instagram, WhatsApp Cloud, templates and ads). Applies to every company on save, without a restart.",
				version: "Version",
				released: "Released",
				expires: "Expires",
				noExpiry: "No date",
				inUse: "in use",
				save: "Save",
				saved: "Meta version updated",
				versionSection: "API version",
				mainApp: "Facebook and Instagram app",
				whatsappApp: "WhatsApp Cloud app (connection, coexistence and templates)",
				appId: "App ID",
				appSecret: "App secret",
				configId: "Configuration ID",
				secretSaved: "Saved · type to change it",
				missingApp: "The Meta app is not configured",
			},
			backendErrors: {
				ERR_META_GRAPH_VERSION_INVALID: "The version must look like v26.0.",
				ERR_FACEBOOK_COMMENT_WAITING_CUSTOMER: "You already sent the private message to this comment. You can write again once the person replies.",
				ERR_FACEBOOK_COMMENT_REPLY_EXPIRED: "More than 7 days have passed since the comment. Facebook no longer allows a private reply.",
				ERR_FACEBOOK_COMMENT_TEXT_ONLY: "A private reply to a comment can only be text.",
				ERR_FACEBOOK_COMMENT_REPLY_FAILED: "The private reply to the comment could not be sent.",
				ERR_KNOWLEDGE_STORE_NOT_CONFIGURED: "The knowledge base is not configured on the server (the KNOWLEDGE_SUPABASE_* variables are missing).",
				ERR_KNOWLEDGE_USAGE_REQUIRED: "Write when the agent should look up this document.",
				ERR_KNOWLEDGE_NO_ITEMS_LEFT: "The record needs at least one rule. If it is not useful, reject it.",
				ERR_KNOWLEDGE_SUPABASE_FORBIDDEN: "Supabase did not allow writing. The connection needs the service_role key.",
				ERR_KNOWLEDGE_SUPABASE_NO_TABLE: "The knowledge_vectors table is missing in Supabase (run the setup SQL).",
				ERR_KNOWLEDGE_SUPABASE_ERROR: "Supabase returned an error while publishing. Try again.",
				ERR_KNOWLEDGE_EMBEDDING_FAILED: "The vectors could not be generated with OpenAI. Try again.",
				ERR_KNOWLEDGE_NOTHING_APPROVED: "There are no approved rules to publish.",
				ERR_KNOWLEDGE_NOT_READY: "The document is not ready to publish yet.",
				ERR_KNOWLEDGE_UNPUBLISH_FIRST: "Unpublish the document before processing it again.",
				ERR_KNOWLEDGE_EMPTY_PATH: "Enter the location in the document.",
				ERR_KNOWLEDGE_ONLY_PDF: "Only PDF files are accepted.",
				ERR_KNOWLEDGE_NAME_REQUIRED: "Enter a name for the document.",
				ERR_KNOWLEDGE_EMPTY_TEXT: "Write the text before saving.",
				ERR_KNOWLEDGE_TEXT_TOO_LONG: "The text is too long. Split it into several documents.",
				ERR_KNOWLEDGE_DUPLICATE_TEXT: "That exact text is already saved.",
				ERR_KNOWLEDGE_ASSISTANT_GOAL_REQUIRED: "Write what the agent should know.",
				ERR_PROMPT_BUILDER_GOAL_REQUIRED: "Write what the agent has to do.",
				ERR_TRANSCRIPTION_NO_AUDIO: "No audio arrived to transcribe. Try again.",
				ERR_PROMPT_BUILDER_TOO_LONG: "The prompt is too long to review at once.",
				ERR_NO_PROMPT_FOUND: "Prompt not found.",
				ERR_KNOWLEDGE_SOURCE_TYPE: "Only PDF or TXT files can be attached.",
				ERR_KNOWLEDGE_SOURCE_NO_TEXT: "No text could be read from the file. If it is a scanned PDF, upload it with \"Upload PDF\".",
				ERR_KNOWLEDGE_SOURCE_NOT_FOUND: "The attached manual is no longer available. Attach it again.",
				ERR_KNOWLEDGE_NO_API_KEY: "That agent has no OpenAI key configured.",
				ERR_KNOWLEDGE_DUPLICATE_FILE: "That same file was already uploaded for this agent.",
				ERR_KNOWLEDGE_NOT_FOUND: "Document not found.",
				ERR_KNOWLEDGE_ENTRY_NOT_FOUND: "Record not found.",
				ERR_KNOWLEDGE_BUSY: "The document is being processed. Wait until it finishes.",
				ERR_KNOWLEDGE_INTERRUPTED: "Processing was interrupted (for example, by a server restart). Process it again.",
				ERR_KNOWLEDGE_INVALID_COUNTRY: "The country is not valid.",
				ERR_KNOWLEDGE_ITEMS_MISMATCH: "The rules don't match the record. Reload the page.",
				ERR_KNOWLEDGE_EMPTY_ITEM: "No rule can be empty.",
				ERR_KNOWLEDGE_INVALID_STATUS: "Invalid status.",
				ERR_PROMPT_COACH_NO_VALID_EDIT: "I couldn't turn the correction into a valid prompt change. Try saying it differently, more specifically.",
				ERR_PROMPT_COACH_EMPTY_CORRECTION: "Write what went wrong or what the agent should have done.",
				ERR_PROMPT_TEST_EMPTY_MESSAGE: "Type a message.",
				ERR_PROMPT_VOICE_TEST_SPECIALIST: "Specialists can only be tested by text.",
				ERR_PROMPT_VOICE_TEST_OPENAI: "OpenAI couldn't start the test call. Check the agent's API key and voice model.",
				ERR_PROMPT_MUST_BE_VOICE: "This is a call connection: it only accepts Call prompts.",
				ERR_PROMPT_MUST_BE_TEXT: "Only Text prompts can be assigned here.",
				ERR_CLOSE_REASON_REQUIRED_FOR_AD: "This chat came from an ad: pick a close reason before closing it.",
				ERR_NO_OTHER_WHATSAPP:
					"There must be at lest one default WhatsApp connection.",
				ERR_NO_DEF_WAPP_FOUND:
					"No default WhatsApp found. Check connections page.",
				ERR_WAPP_NOT_INITIALIZED:
					"This WhatsApp session is not initialized. Check connections page.",
				ERR_WAPP_CHECK_CONTACT:
					"Could not check WhatsApp contact. Check connections page.",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Could not download media from WhatsApp. Check connections page.",
				ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
				ERR_SENDING_WAPP_MSG:
					"Error sending WhatsApp message. Check connections page.",
				ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
				ERR_OTHER_OPEN_TICKET:
					"There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED: "Session expired. Please login.",
				ERR_USER_CREATION_DISABLED:
					"User creation was disabled by administrator.",
				ERR_NO_PERMISSION: "You don't have permission to access this resource.",
				ERR_NO_QUEUE_FOUND: "Department not found.",
				ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
				ERR_NO_SETTING_FOUND: "No setting found with this ID.",
				ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
				ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
				ERR_NO_USER_FOUND: "No user found with this ID.",
				ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE: "Error while creating message on database.",
				ERR_CREATING_TICKET: "Error while creating ticket on database.",
				ERR_FETCH_WAPP_MSG:
					"Error fetching the message in WhtasApp, maybe it is too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"This color is already in use, pick another one.",
				ERR_WAPP_GREETING_REQUIRED:
					"Greeting message is required if there is more than one queue.",
			},
		},
	},
};

export { messages };
